import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="legal-page container py-5">
      <h1 className="mb-4">隐私政策</h1>

      <p className="text-muted mb-4">
        我们非常重视您的个人信息和隐私保护。本隐私政策旨在向您说明，在您使用 GitHub AI 平台服务时，我们如何收集、
        使用、存储和保护您的个人信息，以及您享有的权利。
      </p>

      <h3>一、本政策的适用范围</h3>
      <p>
        本政策适用于您通过网站（包括 Web 前端及后续可能扩展的相关产品形态）访问和使用 GitHub AI
        提供的各项服务。如我们就某些特定服务另行制定隐私条款，则该等条款与本政策构成一个整体。
      </p>

      <h3>二、我们收集的信息</h3>
      <ul>
        <li>
          <strong>账户信息：</strong>
          包括手机号、用户名、密码（仅以不可逆形式存储）、是否为管理员、是否为付费用户、账号创建时间、最近登录时间等。
        </li>
        <li>
          <strong>配置信息：</strong>
          包括您主动配置的 LLM 接口地址、模型名称、API Key 掩码信息、GitHub Token 掩码信息等，用于为您提供 AI 解读和更高的
          GitHub API 额度。我们不会在前端展示完整密钥。
        </li>
        <li>
          <strong>使用信息：</strong>
          包括搜索条件、搜索历史（如有保存）、收藏项目、反馈内容、AI 对话内容（如功能开启）等，用于为您提供服务记录和体验优化。
        </li>
        <li>
          <strong>日志与设备信息：</strong>
          包括 IP 地址、浏览器类型、操作系统信息、访问时间、请求 URL 等，用于安全审计、错误排查和统计分析。
        </li>
        <li>
          <strong>Cookie / 本地存储信息：</strong>
          如会话令牌、界面主题、语言偏好等，用于保持登录状态和提升使用体验。
        </li>
      </ul>

      <h3>三、我们如何使用这些信息</h3>
      <ul>
        <li>用于创建和维护用户账号，提供登录验证和身份识别。</li>
        <li>用于执行搜索、收藏、Trending 展示、AI 解读等核心功能。</li>
        <li>用于改进和优化产品功能、性能和安全性，例如错误监控和访问统计。</li>
        <li>在获得您授权或法律允许的情况下，用于向您发送与服务相关的重要通知。</li>
        <li>不会超出上述目的使用您的个人信息，除非事先征得您的明示同意或法律法规另有规定。</li>
      </ul>

      <h3>四、信息的存储与保护</h3>
      <ul>
        <li>除法律法规另有要求外，我们会在实现服务目的所必需的期限内保存您的个人信息。</li>
        <li>我们采用合理的安全措施保护您的信息，防止未经授权的访问、泄露、篡改或毁损。</li>
        <li>尽管已采取合理的安全保护措施，但互联网环境下无法保证信息 100% 安全，您也应妥善保管账号密码等信息。</li>
      </ul>

      <h3>五、信息的共享、转让与公开披露</h3>
      <ul>
        <li>
          我们不会向第三方出售您的个人信息。仅在以下情形下，我们可能共享或披露您的信息：
          <ul>
            <li>事先获得您的明示授权或同意；</li>
            <li>根据法律法规、行政或司法机关的要求；</li>
            <li>为实现核心功能或提供服务所必须，向受托服务商（如云服务商、日志分析服务）共享必要的数据；</li>
            <li>在发生合并、分立、重组等情形时，如涉及个人信息转让，我们会要求新的持有方继续受本政策约束。</li>
          </ul>
        </li>
      </ul>

      <h3>六、您的权利</h3>
      <ul>
        <li>有权查阅、复制、更正、补充您在本平台上的个人信息（通过个人设置或联系客服实现）。</li>
        <li>有权撤回授权或注销账号，在法律法规允许的范围内，我们将删除或匿名化处理相关个人信息。</li>
        <li>如您认为我们的个人信息处理行为损害了您的合法权益，可通过本政策提供的联系方式与我们沟通解决。</li>
      </ul>

      <h3>七、Cookie 和本地存储的使用</h3>
      <p>
        我们使用 Cookie 和浏览器本地存储来维护会话状态、保存界面偏好和提升使用体验。您可通过浏览器设置禁止或清除相关数据，
        但可能会影响登录状态和某些功能的正常使用。
      </p>

      <h3>八、未成年人保护</h3>
      <p>
        本平台主要面向具有完全民事行为能力的成年人。如果您是未成年人，应在监护人同意和指导下使用本平台。
        如发现未成年人在未经监护人同意的情况下提供了个人信息，请监护人及时与我们联系，我们会在核实后尽快删除相关数据。
      </p>

      <h3>九、本政策的更新</h3>
      <p>
        我们可能会根据业务发展或法律法规变化适时更新本政策。对于重大变更，我们会通过网站公告或其他适当方式进行通知。
        在更新生效后，若您继续使用本平台，即视为您接受更新内容。
      </p>

      <h3>十、联系我们</h3>
      <p>
        如您对本隐私政策有任何疑问、意见或投诉，欢迎通过网站底部的联系方式与我们联系，我们会尽快进行处理。
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;

